import { Box, Chip } from '@mui/material';
import { Text } from '@qwickapps/react-framework';

interface DeviceInfoProps {
  deviceInfo?: {
    hostname?: string;
    cpuLoad?: number;
    latencyMs?: number;
  };
}

export default function DeviceInfo({ deviceInfo }: DeviceInfoProps) {
  if (!deviceInfo || (!deviceInfo.hostname && deviceInfo.cpuLoad === undefined && deviceInfo.latencyMs === undefined)) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Text variant="caption" style={{ fontWeight: 'bold', display: 'block', marginBottom: 4, opacity: 0.7 }}>
        Device Information
      </Text>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {deviceInfo.hostname && (
          <Chip
            label={`Device: ${deviceInfo.hostname}`}
            size="small"
            sx={{
              fontSize: '0.75rem',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              color: 'inherit',
            }}
          />
        )}
        {deviceInfo.cpuLoad !== undefined && (
          <Chip
            label={`CPU: ${(deviceInfo.cpuLoad * 100).toFixed(1)}%`}
            size="small"
            sx={{
              fontSize: '0.75rem',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              color: 'inherit',
            }}
          />
        )}
        {deviceInfo.latencyMs !== undefined && (
          <Chip
            label={`Latency: ${deviceInfo.latencyMs}ms`}
            size="small"
            sx={{
              fontSize: '0.75rem',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              color: 'inherit',
            }}
          />
        )}
      </Box>
    </Box>
  );
}
